import axios from "axios"
import ApplicationState from "../../../../Stores/applicationStates"

/**
 * @description Fetches the list of document templates.
 * @param {number} page page number of the document template list
 */
export const getEmailList = async (page = 1, limit = 10) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/emails?limit=${limit}&page=${page}&sort=-1&sortBy=date`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const deleteEmailTemp = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      const { data } = await axios.delete(`/api/swagger/v2/templates/emails/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })

      //api error checking
      if (data.error && !data.success) {
        throw data.errorCode
      }
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
